<template>
    <v-container fluid>
        <v-row>
            <v-col
                    md="6"
                    offset-md="3">
                <p class="display-2 text-sm-center">How It Works</p>
                <v-divider class="my-3"></v-divider>
                <p class="body-1 ma-8">Local Restaurants are struggling to keep the lights on. Not only are they suffering from lower order volume,
                but the majority of those orders are placed within 3-4 hours of the day. The rest of those open hours are operating at a loss of income.</p>
                <p class="body-1 ma-8"><b>LOKL</b> partners with local restaurants to encourage customers to order during the off-hours. Since these hours are usually at
                    less-than-ideal times, restaurants offer a discount or <b>Promo</b> as an incentive. You're rewarded for supporting your local restaurants, without giving money
                to the big delivery apps!</p>
                <p class="body-1 ma-8">If you find a <b>Promo</b> that you like, just enter your email and we'll send it over - no sign-up necessary. Since we're still in beta
                    and doing market-fit testing, we use email to gauge interest. You get deals to your local eateries and we get validation, a win-win! <u>We won't spam you, pinky swear!</u></p>
                <v-divider class="my-3"></v-divider>
                <div class="subtitle-1 mt-3 mb-3 text-sm-center">Ready to Give Us a Try?</div>
                <div class="text-sm-center">
                    <v-btn large color="warning" class="mx-3" :to="{name:'Promos'}">Yep! Explore Promos</v-btn>
                    <v-btn large color="grey" class="mx-3" :to="{name:'Boo'}">Nah</v-btn>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "Explain"
    }
</script>

<style scoped>

</style>